// "RESPONSABLE" de los formularios de enfermería (020/022/120/SOAPIE): el
// practicante de la sesión, con su nombre en `display` para que las grillas lo
// muestren sin leer el Practitioner de cada registro.
import { formatHumanName } from '@medplum/core';
import type { Practitioner, Reference } from '@medplum/fhirtypes';
import { useMedplumProfile } from '@medplum/react-hooks';

export function useResponsable(): Reference<Practitioner> | undefined {
  const profile = useMedplumProfile();
  if (!profile?.id) return undefined;
  const nombre = profile.name?.[0] ? formatHumanName(profile.name[0]) : undefined;
  // Las sesiones del HCE son de Practitioner (el login de hce-chart no admite otro perfil).
  return { reference: `${profile.resourceType}/${profile.id}`, display: nombre || undefined } as Reference<Practitioner>;
}
